import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
export default function Scores(_ref) {
  var score = _ref.score,
      lost = _ref.lost;
  var gameOver = null;

  if (lost) {
    gameOver = /*#__PURE__*/React.createElement("span", {
      className: "game-over"
    }, 'Game over!');
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "pacman-scores"
  }, /*#__PURE__*/React.createElement("span", {
    className: "running-score"
  }, 'Score: ', score), gameOver);
}
Scores.propTypes = {
  lost: PropTypes.bool.isRequired,
  score: PropTypes.number.isRequired
};